import gql from 'graphql-tag';

const query = gql`
  query {
    fetchFacilityGroups(source: "zentrumhub") {
      id
      name
      culture
      type
    }
  }
`;

export default function fetchFacilityGroups({ apollo }) {
  return apollo.query({
    query,
    variables: {}
  });
}
